import Pagination, { Pagination as NotPurePagination } from './Pagination';
import * as Types from './Pagination.d';
import { PaginationWrapper, Page } from './Pagination.styled';

export { NotPurePagination as Pagination, PaginationWrapper, Page };
export type PaginationProps = Types.PaginationProps;
export * from './Pagination';
export default Pagination;
